module.exports = __webpack_public_path__ + "static/Kubernetes-3a15213ddffc497c558cabac9f1e2c2b.svg";